import { ItemMappingUpdatePage } from "@/features/item-mapping/pages/ItemMappingUpdatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/item-mapping/$id/update")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <ItemMappingUpdatePage id={id} />;
}
